import manifest from "../content/images.json";

// Responsive props for a photo built by scripts/responsive_images.py.
// <img {...pic("villa-front")} alt="..." />  (default sizes suit a full-bleed, object-cover hero: phones are tall, so ask for ~2x the viewport width)
export const pic = (name, { sizes = "(max-width: 640px) 200vw, 100vw", fallback = 1080 } = {}) => {
  const m = manifest[name];
  if (!m) throw new Error(`Unknown image: ${name}`);
  const url = (w) => `/img/${name}-${w}.webp`;
  const src = m.widths.find((w) => w >= fallback) || m.widths[m.widths.length - 1];
  return { src: url(src), srcSet: m.widths.map((w) => `${url(w)} ${w}w`).join(", "), sizes, width: m.w, height: m.h };
};

// Smallest file that still covers the given CSS width on a 2x screen.
export const picSrc = (name, cssWidth = 480) => {
  const m = manifest[name];
  const w = m.widths.find((x) => x >= cssWidth * 2) || m.widths[m.widths.length - 1];
  return `/img/${name}-${w}.webp`;
};
